import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FileTypeValidator } from 'src/app/directives/image-validation';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { InviteBulkUser, ClearAction } from '../store/user-managment.actions';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as Filepond from 'filepond';
import * as  FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { environment } from 'src/environments/environment';
import { BASE_URL } from 'src/app/services/Api.service';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';
Filepond.registerPlugin(FilePondPluginFileValidateType);
import * as fileSaver from 'file-saver';
import { ACCEPTED_FILE_TYPES_FOR_BULK_UPLOAD, ACCEPTED_FILE_TYPES_TEXT, MIME_TYPE_ON_EXTENSION } from 'src/app/app.constants';
@Component({
    selector: 'app-user-bulk-invite',
    templateUrl: './user-bulk-invite.component.html',
    styleUrls: ['./user-bulk-invite.component.scss']
})
export class UserBulkInviteComponent implements OnInit {

    bulkInviteForm: FormGroup
    file;
    userId;
    errorMsgForFile;
    formData: FormData = new FormData();
    @ViewChild('myPond', { static: false }) mypond: any;
    showError: boolean = false;

    pondOptions = {
        class: "file-pond-class",
        multiple: false,
        labelIdle: 'Drag or Upload Files here',
        acceptedFileTypes: ACCEPTED_FILE_TYPES_FOR_BULK_UPLOAD,
        fileValidateTypeLabelExpectedTypesMap: ACCEPTED_FILE_TYPES_TEXT,
        fileValidateTypeLabelExpectedTypes: ['Allowed file formats: {allTypes}'],
        fileValidateTypeDetectType: (source, type) => new Promise((resolve, reject) => {
            if (type === "") {
                let fileExtension = source.name.split('.').pop();
                resolve(MIME_TYPE_ON_EXTENSION(fileExtension));
            } else {
                resolve(type);
            }
        }),
        maxFileSize: '200KB'
        // acceptedFileTypes: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
    };
    fileName: string = '';
    alertTitle: any = "";
    error: any = null;
    token: any;
    constructor(
        private store: Store<AppState>,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        public matDialogRef: MatDialogRef<any>,
        public http: HttpClient,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.matDialogRef.disableClose = true;
        this.alertTitle = data.alertTitle



    }

    ngOnInit() {
        this.store.dispatch(new ClearAction());
        this.userId = this.activatedRoute.snapshot.paramMap.get('id');
        // this.bulkInviteForm = this.fb.group({
        //   // upfile: ['']
        // })
        this.store.select(state => state.auth).pipe(take(1)).subscribe(auth => {
            this.token = auth.accessToken;
        });
        this.store.select(state => state.userManagment.inviteBulkUserRes).subscribe(response => {
            if (Object.keys(response).length) {
                this.matDialogRef.close();
            }
        })
    }

    uploadBulkInvite() {
        if (this.data.type === 'userManagement') {

            if (this.fileName.length) {
                // console.log('TCL: this.bulkInviteForm.valid', this.bulkInviteForm.valid);
                this.formData.set('upfile', this.file);
                console.log('TCL: this.file', this.file);
                console.log('TCL: this.formData', this.formData);
                // console.log('TCL: this.file', this.file);
                this.store.dispatch(new InviteBulkUser(this.formData));
            }
        } else if ((this.data.type === 'projectDashBoard') || (this.data.type === 'compliance')) {
            // let formData =new FormData();
            // formData.set('upfile', this.file);
            if (this.error == null) {

                if (this.fileName.length) {
                    this.matDialogRef.close(this.file);
                }
            }

        }
    }

    handleFileInput(event) {
        if (event.target.files.length > 0) {
            this.file = event.target.files[0];
        }
    }
    pondHandleAddFile(event) {
        if (event.error === null) {
            this.showError = false;
            this.error = null
            this.file = event.file.file;
            this.fileName = event.file.filename
        }
        else {
            this.showError = true
            this.error = event.error
        }
    }
    pondFileRemoved(event) {
        this.file = {};
        this.fileName = '';
        this.showError = false;
    }
    cancelClicked() {
        this.matDialogRef.close('');
    }

    async downloadSampleExcel() {
        let excelUrl = '';
        if (this.data.type === 'projectDashBoard') {
            excelUrl = `${BASE_URL}/miscellaneous/download-bulk-task-excel`;
        } else if (this.data.type === 'compliance') {
            excelUrl = `${BASE_URL}/miscellaneous/download-compliance-excel`;
        } else {
            excelUrl = `${BASE_URL}/miscellaneous/download-bulk-user-excel`;
        }
        // this.http.get(excelUrl, {
        //     headers: {
        //       'Authorization': 'Bearer ' + this.token,
        //        responseType: 'blob'
        //     }
        //   }).subscribe((res: any) => {
        //   const blob = new Blob(res, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        //   saveAs(blob, "file.pdf");
        //   });
        window.open(excelUrl);
        // fileSaver.saveAs(excelUrl, 'a');
    }
}
